import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../../lib/analytics';

export default function TrackedLink({
  to,
  ctaId,
  ctaLocation,
  destination,
  modelName,
  className,
  style,
  children,
  onClick,
}) {
  const handleClick = (event) => {
    trackEvent('cta_click', {
      cta_id: ctaId,
      cta_location: ctaLocation,
      destination: destination || to,
      ...(modelName ? { model_name: modelName } : {}),
    });
    onClick?.(event);
  };

  return (
    <Link to={to} className={className} style={style} onClick={handleClick}>
      {children}
    </Link>
  );
}
